// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"273":"57feb684","678":"6e44abfb","955":"6e44abfb"}[chunkId] + ".chunk.css";
};